import React from 'react'
import "./footer.scss"

const Footer = () => {
  return (
    <div className='footer'>
      <span>Flächenlagen Dispositions Tool Landkreis Leer</span>
      <span>© Martin Stebner</span>
    </div>
  )
}

export default Footer